export default "__VITE_ASSET__DWHIVq1x__"